import { useSync } from '../sync/SyncProvider';
import { useT } from '../i18n';
import styles from './ContentSetupOverlay.module.css';

// Der Datenabgleich laeuft weiter, waehrend die App bedienbar bleibt. Bewusst
// KEINE Prozentzahl: ohne Bild-Voll-Prefetch deckt der Fortschritt nur die
// kleine Daten-Phase (0..10 %) ab und liesse eine unehrliche Zahl stehen.
// role=status ohne Prozentaenderungen — Screenreader hoeren nur den Wechsel
// zwischen Laden, Warten auf Netz und Fehler.
export function ContentSetupOverlay() {
  const { status, bootstrapProgress } = useSync();
  const { t } = useT();
  if (status !== 'bootstrapping') return null;
  const message = bootstrapProgress?.dataError ? 'app.content_setup_error_title'
    : bootstrapProgress?.waitingForNetwork ? 'app.content_setup_waiting' : 'app.content_setup_title';
  return <div className={styles.backgroundSync} role="status" aria-live="polite">{t(message)}</div>;
}
